import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-xs md:text-sm text-gray-900"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("dl", null, [
    _createElementVNode("dt", {
      class: _normalizeClass(_ctx.css)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("dd", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true)
  ]))
}